module.exports = {"220771200":"兴原乡","220771599":"松原经济技术开发区特殊乡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220771.json
// module id = 745
// module chunks = 0